// extracted by mini-css-extract-plugin
export default {"edit":"edit_edit__J8M0T","delete":"edit_delete__cS6Rb"};